<template>
  <div class="shopping-cart">
    <div class="no-goods" v-if="list.length===0">
      <div class="bg"></div>
      <div class="text">购物车空空如也~</div>
      <div class="btn-con">
        <div class="btn btn-1" @click="goMall">去逛逛</div>
        <div class="btn" @click="goCollection">查看收藏</div>
      </div>
    </div>

    <div class="has-goods" v-if="list.length>0">
      <div class="header-con" v-if="list.length>0">
        <span class="btn" v-if="!cartEditState" @click="changeStatus(true)">编辑</span>
        <span class="btn" v-if="cartEditState" @click="changeStatus(false)">完成</span>
      </div>
      <div class="shop-list" v-if="reloadList">
        <shop-item
            v-for="(item, i) in list"
            :itemData="item"
            :indexKey="i"
            :key="item.shopId"
            :shopEditClickAll="count"
        ></shop-item>
      </div>
      <div class="bottom-con">
        <div class="status-con">
          <div class="input-con" >
            <van-checkbox
                v-if="!cartEditState"
                ref="allSelect"
                class="checkbox"
                v-model="allChecked"
                :icon-size="15"
                checked-color="#f74646"
                @click="clickAllSelect"
                @change="checkShop"
            />
            <van-checkbox
                v-if="cartEditState"
                ref="editAllSelect"
                class="checkbox"
                v-model="editAllChecked"
                :icon-size="15"
                checked-color="#f74646"
                @click="editAllCheckedShop"
            />
            <div class="text" @click="allClick">全选</div>
          </div>

        </div>
        <div class="price-total-con">
          <div class="total-con" v-if="cartTotalPrice">合计：<span class="red">{{ cartTotalPrice.toFixed(2) }}</span></div>
        </div>
        <div class="btn-con">
          <div class="btn btn-info" v-if="!cartEditState" @click="goSgConfirmOrder">去结算<span>({{ cartTotalGoodsCount>99 ? '99+' : cartTotalGoodsCount }})</span></div>
          <div class="btn btn-delete" v-if="cartEditState" @click="deleteSku">删除</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import shopItem from './components/shopItem'
import { listCartItems, removeFromCart, updateCount } from '@/api/mall/mallOrder'
export default {
  components: {
    shopItem,
  },
  data(){
    return {
      list: [],
      allChecked: false,//普通状态是否全选
      editAllChecked: false,//编辑是否全选
      reloadList: true,
      isAllClick: false,
      count: 1,
    }
  },
  computed:{
    ...mapGetters([
      'cartList',//购物车列表
      'cartEditState',//是否编辑状态
      'cartAllSelect',//是否全选状态
      'cartEditAllSelect',//是否全选状态
      'cartTotalPrice',// 已选商品总价
      'cartTotalGoodsCount',// 已选商品总件数
    ])
  },
  watch: {
    cartAllSelect(val){
      this.allChecked = val
    },
    cartEditAllSelect(val){
      this.editAllChecked = val
    },
    cartEditState(val){
      if(val){
        this.editAllChecked = false
      }
    },
    cartList(data){
      this.list = data
    }
  },
  created(){
    this.$store.dispatch('sg/getLatestAddress').then(()=>{//获取用户最后使用地址
      this.$store.dispatch('sg/getListCartItems')//获取购物车列表
    })
  },
  methods: {
    goMall(){
      this.$router.push({ name: 'mall' })
    },
    goCollection() {
      this.$router.push({ name: 'collection' })
    },
    changeStatus(status){
      this.$store.commit('sg/change_cartEditState', status)
    },

    clickAllSelect(){
      this.isAllClick = true
    },
    checkShop(val){
      if(this.isAllClick){
        let arr = []
        let cartList = this.cartList
        arr = cartList.map(shop=>{
          let shopItems = shop.shopItems.map(goods=>{
            return {skuId: goods.productCode, skuIdSelected: val}
          });
          return {shopId: shop.shopId, shopSelected: val, shopItems}
        })
        this.$store.dispatch('sg/changeBuyCartSelect', arr)
        this.isAllClick = false
      }
    },
    editAllCheckedShop(){
      this.editAllChecked = !this.editAllChecked;
      console.log('editAllCheckedShop', this.editAllChecked)
      let arr = []
      let cartList = this.cartList
      arr = cartList.map(shop=>{
        let shopItems = shop.shopItems.map(goods=>{
          return {skuId: goods.productCode, editSkuIdSelected: this.editAllChecked}
        });
        return {shopId: shop.shopId, editShopSelected: this.editAllChecked, shopItems}
      })
      this.$store.dispatch('sg/changeBuyCartEditSelect', arr)
      this.count++
    },
    allClick(){
      if(this.cartEditState){
        this.editAllCheckedShop()
      }else {
        this.clickAllSelect()
        this.$refs.allSelect.toggle()
      }
    },

    deleteSku(){
      let cartList = Object.assign([], this.cartList)
      let arr = []
      cartList.map(item=>{
        item.shopItems.map(item2=>{
          if(item2.editSkuIdSelected){
            arr.push(item2.cartId)
          }
        })
      })
      // console.log(arr)
      if(arr.length>0){
        this.$dialog.confirm({
          title: '确认要删除这' + arr.length + '种商品吗？',
          // message: '确认要删除这' + arr.length + '种商品吗？'
        }).then(() => {
          // on confirm
          console.log(arr)
          this.$store.dispatch('sg/removeBuyCart', arr)
        }).catch(() => {
          // on cancel
        });
      }
    },

    goSgConfirmOrder(){
      let inviteBuyData = this.session('inviteBuyData') ? this.session('inviteBuyData') : {}
      let arr = []
      let list = Object.assign([], this.cartList)
      list.forEach((item, i)=>{
        let shop = {}
        let arr2 = []
        item.shopItems.forEach((item2, i2)=>{
          if(item2.skuIdSelected){
            let obj = {}
            for (var key in item2){
              if(typeof item2[key]!=='object' || item2[key]===null || item2[key]===undefined ){
                obj[key] = item2[key]
              }
            }
            obj.mapProductDetail = Object.assign({}, item2.mapProductDetail)
            inviteBuyData[item.shopId+'_'+item2.goodsId] = item2.inviteUserId
            arr2.push(obj)
          }
        })
        if(arr2.length){
          shop.shopItems = arr2
          shop.shopId = item.shopId
          shop.mapShopInfo = Object.assign({}, item.mapShopInfo)
          shop.shopSysType = item.shopSysType
          arr.push(shop)
        }
      })
      this.session('inviteBuyData', inviteBuyData)
      console.log(arr)
      localStorage.setItem('sgOrderGoodsList', JSON.stringify(arr))
      this.$router.push({name: 'sgConfirmOrder'})
    },
  }
}
</script>

<style lang="less" scoped>
@url: '../../../assets/my/shoppingCart/';

.shopping-cart{
  position: relative;width: 100%;height: 100%;
  .no-goods{
    padding-top: 104px;padding-bottom: 16px;
    .bg{
      width: 100%;height: 92px;
      background: url("@{url}no-goods.png") no-repeat 50% 50%;
      background-size: 136.5px 91.5px;
    }
    .text{
      text-align: center;color: #999;font-size: 13px;line-height: 1;padding-top: 16px;
    }
    .btn-con{
      padding-top: 50px;
      display: flex;justify-content: center;
      .btn{
        display: inline-flex;justify-content: center;align-items: center;
        width: 125px;height: 35px;border-radius: 18px;font-size: 16px;
        border: 1px solid #1585f3;color: #1585f3;
      }
      .btn-1{
        margin-right: 40px;
      }
    }
  }

  .has-goods{
    position: absolute;left: 0;right: 0;top: 0;bottom: 0;overflow: hidden;
    .header-con{
      height: 36px;text-align: right;padding: 0 12px;
      display: flex;justify-content: flex-end;align-items: center;
      .btn{
        font-size: 16px;color: #1585f3;line-height: 1;
      }
    }
    .shop-list{
      position: absolute;top: 36px;bottom: 50px;left: 0;right: 0;
      overflow-y: auto;
    }
    .bottom-con{
      position: absolute;left: 0;right: 0;bottom: 0;height: 50px;display: flex;
      .status-con{
        display: inline-flex;justify-content: center;align-items: center;
        height: 100%;
        .checkbox{display: inline-flex;padding: 0 12px;height: 100%;}
        .text{
          color: #666;font-size: 14px;padding-right: 10px;height: 100%;
          display: inline-flex;justify-content: center;align-items: center;
        }
      }
      .price-total-con{
        flex: 1;display: inline-flex;height: 100%;align-items: center;
        .total-con{
          font-size: 12px;color: #333;padding-left: 10px;
          .red{
            font-size: 20px;
            color: rgb(247,77,77);
          }
        }
      }
      .btn-con{
        display: inline-flex;width: 148px;height: 100%;justify-content: center;align-items: center;
        .btn{
          width: 124px;height: 39px;font-size: 15px;color: #fff;
          border-radius: 19px;display: inline-flex;justify-content: center;align-items: center;
        }
        .btn-info{
          background-color: #1585f3;
        }
        .btn-delete{
          background-color: #f74d4d;
        }
      }
    }
  }
}
</style>